import gql from 'graphql-tag';

export const ORDER_FOR_SUPER_ADMIN = gql`
  query getOrderForSuperAdmin($id: ID) {
    getOrderForSuperAdmin(id: $id) {
      id
      isVisited
      isEditable
      groupOrderLast4
      hasErrors
      successorOrder {
        id
      }
      fee
      group {
        id
        name
      }
      platformFee
      canceled
      event {
        id
        closeDate
        endDate
        openDate
        name
        startDate
        venue {
          id
          name
        }
      }
      notes
      adminNotes
      addOnDeliveryNotes
      orderItems {
        id
        addOnProduct {
          id
          price
          addOn {
            id
            name
            unitName
          }
        }
        reservation {
          id
          endDate
          rvProduct {
            id
            name
            description
            price
            nightly
            minNights
            rvLot {
              id
              description
              name
              power
              sewer
              water
            }
          }
          rvSpots {
            id
            name
          }
          stallProduct {
            id
            name
            description
            nightly
            price
            minNights
          }
          stalls {
            id
            building {
              id
              name
            }
            name
            description
            status
          }
          startDate
          status {
            id
            name
          }
        }
        quantity
      }
      payments {
        id
        admin {
          id
        }
        amount
        cardBrand
        cardPayment
        createdAt
        last4
        notes
        serviceFee
        stripeFee
        ssChargeId
        ssRefundId
        success
        cardReader
        adminCharge
        discountCodeValue
        discountCodeId
        subtotalBeforeDiscount
        globalDiscountAmount
      }
      groupPayments {
        amount
        isRefund
      }
      total
      user {
        id
        email
        firstName
        fullName
        lastName
        phone
      }
      stallQuestionAnswers {
        id
        questionId
        question
        answerOptions
        answer
        questionType
        required
        minLength
        maxLength
      }
      rvQuestionAnswers {
        id
        questionId
        question
        answerOptions
        answer
        questionType
        required
        minLength
        maxLength
      }
    }
  }
`;
